/**
 * Created by akrio on 2018/4/29.
 */
import app from "../../main";

/**
 * 信息提示框
 */
export const ToastPlugin = {
  install(Vue) {
    const toast = {
      show({ message = "", type = "success" }) {
        app.$message({
          type,
          message,
        });
      },
    };
    Vue.mixin({
      created() {
        this.$toast = toast;
      },
    });
  },
};
